<template>
  <section>
    <div class="row">
      <div class="col-sm-8 offset-sm-2 col-xl-6 offset-xl-3 col-12 p-0">
        <div id="start-booking-form" :class="{'card py-3 shadow-sm': !$mq.phone}">
          <div :class="{'card-body': !$mq.phone}">
            <div class="row">
              <div class="col">
                <div class="text-center">
                  <h3 class="booking-title mt-3">
                    <template v-if="subscriptionTypeId">
                      {{ $t('message.home.subscription_service') }}
                    </template>
                    <template v-else>
                      {{ getServiceParentName() }}
                    </template>
                  </h3>
                  <div class="mb-3">{{ $t('message.booking.new_booking.scroll_down_see_detail') }}</div>
                </div>
              </div>
            </div>

            <!-- Cleaning service -->
            <section v-if="parentService && parentService.can_book_package">
              <!-- Subscription -->
              <subscription-type :subscriptionTypeId="subscriptionTypeId" v-if="subscriptionTypeId"/>
              <!-- Booking Plan -->
              <div class="row" v-else>
                <div class="col">
                  <booking-plan :packageType="packageType" @selectPackageType="selectPackageType"/>
                </div>
              </div>
            </section>

            <!-- User places & provinces -->
            <div class="row">
              <div class="col-12 mt-4">
                <!-- User places -->
                <div class="form-group">
                  <h4 class="pb-2">{{ $t('message.booking.booking_step.my_place') }}</h4>
                  <div class="select-jumbo mb-3" v-if="filteredUserPlaces && filteredUserPlaces.length">
                    <select v-model="selectedUserPlaceId" @change="syncUserPlaceData">
                      <option :value="null">
                        {{ $t('message.booking.booking_step.please_select') }}
                      </option>
                      <option :value="userPlace.id" v-for="userPlace in filteredUserPlaces">{{ userPlace.place_name }}
                      </option>
                    </select>
                  </div>
                  <!-- Provinces -->
                  <div class="select-jumbo">
                    <select v-model="selectedProvinceId"
                            @change="checkChangingCity($event)">
                      <option :value="sortedCities[index].id" v-for="city, index in sortedCities"
                              v-if="sortedCities[index].id > 0">
                        {{ city | multiLangName }}
                      </option>
                    </select>
                  </div>
                </div>
              </div>
              

              <!-- Cleaning service options -->
              <template v-if="parentServiceId === 1">
                <div class="col-12 mt-4">
                  <!-- Place Type -->
                  <div class="form-group">
                    <h4 class="pb-2">{{ $t('message.booking.booking_step.accommodation') }}</h4>
                    <div class="select-jumbo">
                      <select v-model="selectedPlaceSize" @change="setWorkHour">
                        <option :value="sortedPlaceSizes[index].id" v-for="placeSize, index in sortedPlaceSizes">
                          {{ placeSize | multiLangName }}
                        </option>
                      </select>
                    </div>
                    <label class="mt-2 text-primary pl-1">
                      {{ $t('message.booking.booking_step.recommend') }}&nbsp;{{ $t(globalState.durations[selectedPlaceSize]) }}
                    </label>
                    <div class="select-jumbo mt-2">
                      <select v-model="selectedWorkHour" @change="calculateCost">
                        <option :value="index" v-for="workHour, index in globalState.workHours">
                          {{ $t(workHour) }}
                        </option>
                      </select>
                    </div>
                    <div class="mt-2 pl-1 text-orange">
                      * {{ $t('message.booking.new_booking.excluding_break_time') }}
                    </div>
                  </div>
                </div>
              </template>
              <!-- Ironing or Bathroom cleaning service options -->
              <template v-else-if="parentServiceId !== 1 && (parentService && parentService.child_services_text)">
                <div class="col-12 mt-4">
                  <div class="form-group">
                    <h4 class="pb-2">
                      {{ ($i18n.locale === 'th') ? parentService.child_services_text.title_th : parentService.child_services_text.title_en }}
                    </h4>
                    <div class="select-jumbo" :class="{'form-alert': errorSelectedService}">
                      <select v-model="selectedServiceId">
                        <option :value="null">
                          {{ ($i18n.locale === 'th') ? parentService.child_services_text.placeholder_th : parentService.child_services_text.placeholder_en }}
                        </option>
                        <option :value="childServices[index].id" v-for="service, index in childServices">
                          {{ service | multiLangName }}
                        </option>
                      </select>
                    </div>
                    <div v-if="errorSelectedService" class="form-alert-text -status-alert">{{ errorSelectedServiceText }}</div>
                  </div>
                </div>
              </template>
            </div>

            <!-- Thai massage hours -->
            <section v-if="parentServiceId === 7">
              <div class="row mt-3">
                <div class="col-12">
                  <h4 class="pb-2">{{ $t('message.booking.new_booking.choose_massage_hours') }}</h4>
                  <b-form-group class="mt-2">
                    <b-form-radio-group
                      id="btn-radios-2"
                      v-model="selectedServiceId"
                      :options="thaiMassageOptions"
                      buttons
                      class="col no-padding"
                      button-variant="outline-info"
                      name="radio-btn-outline"/>
                  </b-form-group>
                </div>
              </div>
            </section>

             <!-- Ac cleaning services -->
             <section v-if="hasServiceItems">
              <div class="row mt-3">
                <div class="col-12">
                  
                  <div class="d-flex justify-content-start align-items-center">
                    <div class="flex-fill">
                      <h4>{{ $t('message.service_item.select') }}</h4>
                    </div>
                    <div v-if="serviceItems">
                      <a href="" class="text-info" @click.prevent="clearSelectedServiceItems()">
                        {{ $t('message.service_item.clear') }}
                      </a>
                    </div>
                  </div>
                  <div class="card pointer-item mb-1" 
                       :class="[errorServiceItems ? 'border-danger' : 'border-divider']"
                       @click="openServiceItemModal()">
                    <div class="card-body">
                      <div class="d-flex justify-content-start align-items-center" v-if="!serviceItems">
                        <div><img :src="parentService.icon_url" width="24"/></div>
                        <div class="flex-fill px-3">{{ $t('message.service_item.select') }}</div>
                        <div><i class="fal fa-plus-circle text-info fa-lg"></i></div>
                      </div>
                      <div class="d-flex justify-content-start align-items-top" v-else>
                        <div>
                          <img :src="parentService.icon_url" width="32" class="active-svg-icon"/>
                        </div>
                        <div class="flex-fill px-3">
                          <div class="mb-2"><strong>{{ $t('message.service_item.selected_list') }}</strong></div>
                          <div v-for="serviceItem in serviceItems">
                            {{ serviceItem | multiLangName }}: {{ serviceItem.count }} {{ serviceItem.item_unit | multiLangName }}
                          </div>
                          <div class="text-info text-small mt-2">{{ $t('message.service_item.remark') }}</div>
                        </div>
                        <div>
                          <button class="btn btn-outline-info rounded-pill">แก้ไข</button>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div v-if="errorServiceItems" class="form-alert-text -status-alert">{{ $t('message.required_selection') }}</div>
                </div>
              </div>
            </section>

            <!-- Package type -->
            <div v-if="(user && user.flagBlack === 0) && !subscriptionTypeId">
              <div class="row mt-3" v-if="packageType">
                <div class="col-12">
                  <h4>{{ $t('message.booking.new_booking.select_package_type') }}</h4>
                </div>
                <div class="col-12">
                  <div class="card shadow-sm">
                    <div class="card-body">
                      <div class="exp">
                        <div class="checkbox">
                          <input type="checkbox"
                                 id="package_unlimited"
                                 @change="selectPackageType('unlimited')"
                                 :checked="packageType && packageType.category === 'unlimited'"/>
                          <label class="mb-0" for="package_unlimited">
                            <span><!-- This span is needed to create the "checkbox" element --></span>
                            {{ $t('message.booking.new_booking.package_type_unlimited') }}
                          </label>
                        </div>
                      </div>
                      <div class="exp pt-4">
                        <div class="checkbox">
                          <input type="checkbox"
                                 id="package_flexible"
                                 @change="selectPackageType('flexible')"
                                 :checked="packageType && packageType.category === 'flexible'"/>
                          <label class="mb-0" for="package_flexible">
                            <span><!-- This span is needed to create the "checkbox" element --></span>
                            {{ $t('message.booking.new_booking.package_type_flexible') }}
                            <div class="d-inline-block text-comment text-secondary pt-1" style="padding-left: 2.2rem">
                              {{ $t('message.booking.new_booking.booking_type_flexible_remark') }}
                            </div>
                          </label>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div v-else>
                <div class="col-12 pt-3">
                  <h4>{{ $t('message.booking.new_booking.select_booking_type') }}</h4>
                </div>
                <div class="col-12">
                  <div class="card border-divider">
                    <div class="card-body ">
                      <div class="exp">
                        <div class="checkbox">
                          <input type="radio"
                                 name="bookingType"
                                 id="normal_booking"
                                 value="normal"
                                 v-model="bookingType"/>
                          <label class="mb-0" for="normal_booking">
                            <span><!-- This span is needed to create the "checkbox" element --></span>
                            {{ $t('message.booking.new_booking.booking_type_normal') }}
                          </label>
                        </div>
                      </div>
                      <div class="exp pt-4">
                        <div class="checkbox">
                          <input type="radio"
                                 name="bookingType"
                                 id="flexible_booking"
                                 value="flexible"
                                 v-model="bookingType"/>
                          <label class="mb-0" for="flexible_booking">
                            <span><!-- This span is needed to create the "checkbox" element --></span>
                            {{ $t('message.booking.new_booking.booking_type_flexible') }}
                            <div class="d-inline-block text-comment text-secondary pt-1" style="padding-left: 2.2rem">
                              {{ $t('message.booking.new_booking.booking_type_flexible_remark') }}
                            </div>
                          </label>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- Package type discounts -->
            <div class="row my-3" v-if="packageType && packageType.category === 'flexible'">
              <div class="col-12">
                <h4 class="pb-2">{{ $t('message.booking.new_booking.how_many_package') }}</h4>
                <div class="select-jumbo">
                  <select v-model="packageTypeDiscount" @change="calculateCost">
                    <option :value="packageTypeDiscount"
                            v-for="packageTypeDiscount in packageType.package_type_discounts">
                      {{ packageTypeDiscount | multiLangName }}
                    </option>
                  </select>
                </div>
              </div>
            </div>

            <!-- Pick a date time -->
            <section v-if="bookingType === 'normal'">
              <div class="row pt-3" v-if="!packageType || (packageType && packageType.category === 'unlimited')">
                <div class="col-12">
                  <h4 class="pb-2">{{ $t('message.booking.new_booking.pick_a_date') }}</h4>
                </div>
                <div class="col-12 mb-4" v-if="packageType">
                  <div class="text-remark mt-1">
                    {{ $t('message.booking.new_booking.select_multi_dates') }} - {{ packageType | multiLangName }}
                  </div>
                  <multi-dates-calendar
                    :maxNum="packageType.num_per_package"
                    :serviceId="parentServiceId"
                    :provinceId="selectedProvinceId"
                    :sameDayBookingConfig="calendarData.sameDayBookingConfig"
                    @selectDate="onDateChange"/>
                  <section class="mt-4" v-if="multiDates && multiDates.length > 0">
                    <package-discount :numDates="multiDates.length" :packageType="packageType"/>
                    <span class="badge badge-pill py-2 px-3 mr-2 mb-2 badge-light" v-for="date in multiDates">
                    {{ date | shortDate }}
                  </span>
                  </section>
                  <div v-if="errorBookingDate" class="form-alert-text -status-alert">{{ errorBookingDateText }}</div>
                </div>
                <div class="col-6 pr-2" v-if="packageType === null">
                  <div class="form-group">
                    <!-- @change="checkBookingDate" -->
                    <input type="text"
                           :placeholder="$i18n.t('message.booking.booking_step.date')"
                           class="form-control -date-picker input-jumbo"
                           :class="{'form-alert': errorBookingDate}"
                           v-pikadayBooking="calendarData"
                           ref="cleaningDate"
                           readonly/>
                    <span class="far fa-calendar-alt input-text-icon"></span>
                    <div v-if="errorBookingDate" class="form-alert-text -status-alert">{{ errorBookingDateText }}</div>
                  </div>
                </div>
                <div :class="(packageType === null) ? 'col-6 pl-2' : 'col-12'">
                  <div class="form-group">
                    <template v-if="availableTimes && availableTimes.length > 0">
                      <div class="select-jumbo" :class="{'form-alert': errorBookingTime}">
                        <select style="background: white;" v-model="selectedTime">
                          <option :value="null">{{ $t('message.booking.new_booking.time') }}</option>
                          <option :value="time" v-for="time in availableTimes">{{ time }}</option>
                        </select>
                        <span class="far fa-clock input-text-icon"></span>
                      </div>
                      <div v-if="errorBookingTime" class="form-alert-text -status-alert">{{ $t('message.required_selection') }}</div>
                    </template>
                    <template v-else>
                      <div class="text-orange pt-2">{{ $t('message.alert.sold_out') }}</div>
                    </template>
                  </div>
                </div>
              </div>
              <div class="row" v-if="parentServiceId === 7">
                <div class="col-12 text-remark">
                  <div class="text-success" v-if="availableService.available_number > 0">
                    <i class="fas fa-user mr-1"></i>
                    {{ $t('message.booking.new_booking.left_number', { num: availableService.available_number }) }}
                  </div>
                  <div class="text-orange" v-else>
                    <i class="fas fa-user mr-1"></i>
                    {{ $t('message.alert.no_available_service') }}
                  </div>
                </div>
              </div>
            </section>
            <div class="row">
              <div class="col-12">
                <hr>
              </div>
            </div>

            <div class="row mt-3">
              <div class="col-8">
                <label class="text-dark">
                  {{ $t('message.booking.new_booking.subtotal') }}
                </label>
              </div>
              <div class="col-4 text-right">
                <h3 class="text-primary">
                  {{ subtotal | currency }}
                </h3>
              </div>
            </div>

            <div class="row mt-3">
              <div class="col-12">
                <button class="btn btn-lg btn-info btn-block -cyan"
                        :disabled="checkDisabledButton"
                        @click="goToCheckout">
                  {{ $t('message.booking.new_booking.continue') }}
                </button>
              </div>
            </div>

          </div>
        </div>
      </div>
    </div>
    <hr class="mx-3 my-4" v-if="$mq.phone">
    <!-- Subscription detail modal -->
    <subscription-detail-modal v-if="Number(this.$route.query.subscriptionTypeId) === 1" 
                               ref="subscriptionDetailModal"/>
    <!-- Service items modal -->
    <service-item-modal v-if="hasServiceItems" 
                        ref="serviceItemModal"
                        :parentService="parentService"
                        @selectServiceItems="setServiceItems"/>
  </section>
</template>

<script>
  import { mapGetters, mapState } from 'vuex'
  import moment from 'moment-timezone'
  import SubscriptionDetailModal from './components/SubscriptionDetailModal'
  import ServiceItemModal from '../components/ServiceItemModal'
  import SubscriptionType from './components/SubscriptionType'
  import BookingPlan from './components/BookingPlan'
  import PackageDiscount from './components/PackageDiscount'
  import { BFormGroup, BFormRadioGroup } from 'bootstrap-vue'
  import insiderHelpers from '../../../helpers/insiderHelpers'
  import packageHelpers from '../../../helpers/packageHelpers'
  import provinceHelpers from '../../../helpers/provinceHelpers'
  import serviceHelpers from '../../../helpers/serviceHelpers'
  import timeHelpers from '../../../helpers/timeHelpers'
  import userEventLogHelpers from '../../../helpers/userEventLogHelpers'

  export default {
    components: {
      BFormGroup,
      BFormRadioGroup,
      SubscriptionDetailModal,
      ServiceItemModal,
      SubscriptionType,
      BookingPlan,
      PackageDiscount
    },
    data () {
      return {
        countDialog: 0,
        parentServiceId: 0,
        parentService: null,
        selectedServiceId: 1,
        subscriptionTypeId: null,
        selectedDate: null,
        selectedTime: null,
        selectedUserPlaceId: null,
        selectedProvinceId: 1,
        selectedPlaceSize: 1,
        selectedWorkHour: '2.0',
        calendarData: {
          date: null,
          isToday: true,
          sameDayBookingConfig: null,
          serviceId: null,
          provinceId: null
        },
        sortBy: (this.$i18n.locale === 'th') ? 'name_th' : 'name_en',
        subtotal: null,
        errorBookingDate: false,
        errorBookingDateText: null,
        errorBookingTime: false,
        errorSelectedService: false,
        errorSelectedServiceText: null,
        errorServiceItems: false,
        availableTimes: null,
        todayDate: null,
        initNextAvailableTime: null,
        endHour: 20,
        thaiMassageOptions: [],
        childServices: null,
        multiDates: null,
        packageType: null,
        packageTypeDiscount: null,
        bookingType: 'normal',
        serviceItems: null
      }
    },
    computed: {
      ...mapGetters({
        globalState: 'globalVal/getState',
        preBookingData: 'booking/getPreBookingData',
        state: 'booking/getState',
        user: 'auth/getUser'
      }),
      ...mapState('booking', [
        'availableService'
      ]),
      hasServiceItems () {
        let hasServiceItems = null
        if (this.parentService && this.parentService.has_service_items) {
          hasServiceItems = this.parentService.has_service_items
        }
        return hasServiceItems
      },
      sortedCities () {
        let provinces = null
        provinces = this._.orderBy(this.globalState.cities, [this.sortBy], ['asc'])
        if (this.globalState.configData && this.globalState.configData.specific_service_provinces) {
          const serviceProvince = this.getServiceProvince()
          if (serviceProvince) {
            provinces = []
            for (const provinceId of serviceProvince.province_ids) {
              provinces.push(this.globalState.cities[provinceId])
            }
            provinces = this._.orderBy(provinces, [this.sortBy], ['asc'])
          }
        }
        return provinces
      },
      filteredUserPlaces () {
        let userPlaces = []
        if (this.state.userPlaces) {
          userPlaces = this.state.userPlaces
          if (this.globalState.configData && this.globalState.configData.specific_service_provinces) {
            const serviceProvince = this.getServiceProvince()
            if (serviceProvince) {
              userPlaces = []
              for (const userPlace of this.state.userPlaces) {
                if (serviceProvince.province_ids.includes(userPlace.province_id)) {
                  userPlaces.push(userPlace)
                }
              }
            }
          }
        }
        return userPlaces
      },
      sortedPlaceSizes () {
        return this._.orderBy(this.globalState.placeSizes, ['id'], ['asc'])
      },
      checkDisabledButton () {
        let result = false
        if (this.parentServiceId === 7 && this.availableService.available_number <= 0) {
          result = true
        }
        if (this.availableTimes && this.availableTimes.length === 0) {
          result = true
        }
        return result
      }
    },
    watch: {
      selectedTime () {
        if (this.selectedTime) {
          this.errorBookingTime = false
        }
      },
      packageType () {
        // Check package selection
        if (this.packageType) {
          this.availableTimes = this.globalState.arrTimes
          this.selectedTime = '10:00'
        }
      },
      multiDates () {
        this.calculateCost()
      },
      selectedProvinceId () {
        if (this.packageType) {
          this.clearSelectedMultiDates()
        } else {
          this.clearSelectedSingleDate()
        }
        this.calendarData.provinceId = this.selectedProvinceId
        this.generateChildServices()
      },
      selectedServiceId () {
        this.updateServiceData()
      },
      user () {
        this.fetchUserPlaces()
        this.goToCheckout()
      },
      parentServiceId () {
        if (this.parentServiceId === 1) {
          this.selectedServiceId = 1
        } else if (this.parentService.has_service_items) {
          this.selectedServiceId = this.parentService.id
        } else if (this.parentServiceId === 7) {
          this.selectedServiceId = 8
        } else {
          this.selectedServiceId = null
        }
        this.calculateCost()
      },
      'calendarData.date': function (newVal, oldVal) {
        this.checkBookingDate()
        this.checkAvailableService()
        if (!this.selectedTime) {
          this.selectedTime = this.availableTimes[0]
        }
      },
      subtotal () {
        if (this.subtotal) {
          // Insider product page event
          const totalPrice = serviceHelpers.converStringToNumber(this.subtotal)
          const productParams = {
            user: this.user,
            serviceId: this.selectedServiceId,
            provinceId: this.selectedProvinceId,
            totalPrice: totalPrice,
            bookingCountType: (!this.subscriptionTypeId && !this.packageType) ? 'one_time' : 'multiple_times',
            isNoDateTimeBooking: (this.bookingType === 'flexible')
          }
          insiderHelpers.productViewEvent(productParams)
        }
      }
    },
    methods: {
      clearSelectedMultiDates () {
        this.$refs.cleaningDate.value = ''
        this.$refs.cleaningDate.clear()
      },
      clearSelectedSingleDate () {
        this.calendarData.date = null
      },
      getServiceParentName () {
        if (this.parentServiceId && this.globalState && this.globalState.services) {
          const serviceName = (this.$i18n.locale === 'th') ? this.globalState.services[this.parentServiceId].name_th : this.globalState.services[this.parentServiceId].name_en
          return serviceName
        }
        return ''
      },
      getServiceProvince () {
        const serviceProvince = this.globalState.configData.specific_service_provinces.find(data => {
          if (data.service_id === this.parentServiceId) {
            return data
          }
          return null
        })
        return serviceProvince
      },
      onDateChange (selectedDate, datePicker) {
        this.multiDates = datePicker
        const numDates = this.multiDates.length
        switch (this.packageType.category) {
          case 'normal':
            if (numDates === this.packageType.num_per_package) {
              this.errorBookingDate = false
            }
            break
          case 'unlimited':
            if (numDates >= this.packageType.min_qty && numDates <= this.packageType.num_per_package) {
              this.errorBookingDate = false
            }
            break
        }
      },
      openSubscriptionDetailModal () {
        this.$refs.subscriptionDetailModal.showSubscriptionDetailModal(true)
      },
      openServiceItemModal () {
        this.$refs.serviceItemModal.showModal(true, Number(this.selectedProvinceId))
      },
      applySubscription (subscriptionTypeId) {
        this.subscriptionTypeId = subscriptionTypeId
        // Re-calculate cost
        this.calculateCost()
        // Open modal
        if (subscriptionTypeId) {
          this.openSubscriptionDetailModal()
        }
      },
      checkBookingDate () {
        if (this.calendarData.date) {
          const bookingDate = this.calendarData.date
          const today = moment().format('DD/MM/YYYY')
          const nextDay = moment().add(1, 'days').format('DD/MM/YYYY')
          const currentHour = moment().format('H')
          this.errorBookingDate = false

          if (bookingDate === today) {
            let nextAvailableTime = timeHelpers.getNextAvailableTime()
            if (currentHour < 7) {
              nextAvailableTime = '10:00'
            }
            this.setAvailableTimes(nextAvailableTime)
          } else if (bookingDate === nextDay && currentHour >= this.endHour) {
            this.setAvailableTimes('10:00')
          } else {
            this.availableTimes = this.globalState.arrTimes
          }
        }
      },
      clearOldBookingData () {
        this.$store.commit('booking/SET_SELECTED_PROFESSIONAL', null)
        this.$store.commit('booking/SET_PRE_CHECKOUT_DATA', null)
        this.$store.commit('promoCode/SET_APPLIED_PROMO_CODE', null)
        this.$store.commit('extras/SET_APPLIED_EXTRAS', null)
        this.$store.commit('extras/SET_HAS_APPLIED_EXTRAS', false)
      },
      setFormData () {
        if (this.preBookingData) {
          if (this.$refs.cleaningDate) {
            this.$refs.cleaningDate.value = ('cleaning_date' in this.preBookingData) ? this.preBookingData.cleaning_date : ''
          }
          this.calendarData.date = ('cleaning_date' in this.preBookingData) ? this.preBookingData.cleaning_date : null
          this.selectedTime = ('cleaning_time' in this.preBookingData) ? this.preBookingData.cleaning_time : '10:00'
          this.selectedUserPlaceId = ('user_place_id' in this.preBookingData) ? this.preBookingData.user_place_id : null
          this.selectedProvinceId = ('province_id' in this.preBookingData) ? this.preBookingData.province_id : 1
          this.selectedPlaceSize = ('place_size_id' in this.preBookingData) ? this.preBookingData.place_size_id : 1
          this.selectedWorkHour = ('work_hour' in this.preBookingData) ? this.preBookingData.work_hour : '2.0'
        } else {
          if (this.$refs.cleaningDate) {
            this.$refs.cleaningDate.value = ''
          }
          this.calendarData.date = null
          this.selectedTime = '10:00'
          this.selectedUserPlaceId = null
          this.selectedProvinceId = 1
          this.selectedPlaceSize = 1
          this.selectedWorkHour = '2.0'
        }

        if (this.selectedProvinceId === null || typeof this.selectedProvinceId === 'undefined' || this.selectedProvinceId === 0) {
          this.selectedProvinceId = 1
        }

        this.setWorkHour()
        // Set service parent id
        // this.parentServiceId = (this.selectedServiceId === 1) ? 1 : 2
      },
      setPreBookingData () {
        // Clear booking data
        this.clearOldBookingData()

        // Check package type
        const cleaningDate = (!this.packageType && this.bookingType === 'normal') ? this.$refs.cleaningDate.value : null
        const cleaningTime = (!this.packageType && this.bookingType === 'normal') ? this.selectedTime : null

        // Set pre-booking data
        const preBookingData = {
          service_id: this.selectedServiceId,
          subscription_type_id: this.subscriptionTypeId,
          cleaning_date: cleaningDate,
          cleaning_time: cleaningTime,
          user_place_id: this.selectedUserPlaceId,
          province_id: this.selectedProvinceId,
          place_size_id: this.selectedPlaceSize,
          work_hour: this.selectedWorkHour,
          init_work_hour: this.selectedWorkHour,
          package_type: this.packageType,
          package_type_discount: this.packageTypeDiscount,
          payment_method: null,
          omise_customer_id: null
        }

        // Set service items
        if (this.serviceItems) {
          preBookingData.service_items = this.serviceItems
          let workHours = 0.0
          for (const serviceItem of this.serviceItems) {
            if (serviceItem.duration_conditions) {
              workHours += serviceHelpers.getServiceItemDuration(serviceItem.count, serviceItem)
            } else if (serviceItem.duration) {
              workHours += serviceItem.count * serviceItem.duration
            }
          }
          preBookingData.work_hour = workHours
          preBookingData.init_work_hour = workHours
        }

        // Set multi dates for package booking
        if (this.packageType) {
          const sortedMultiDates = this._.sortBy(this.multiDates)
          const multiDatesTimes = []
          for (let key in sortedMultiDates) {
            const dateTime = moment(sortedMultiDates[key]).format('YYYY-MM-DD') + ' ' + this.selectedTime
            multiDatesTimes.push(dateTime)
          }
          preBookingData.multi_dates_times = multiDatesTimes
        }

        this.$store.commit('booking/SET_PRE_BOOKING_DATA', preBookingData)

        // Set total price
        const costData = {
          totalPrice: this.subtotal
        }
        this.$store.commit('booking/SET_BOOKING_COST', costData)
      },
      formValidation () {
        let result = true
        if (!this.selectedServiceId) {
          this.errorSelectedServiceText = this.$i18n.t('message.required_selection')
          this.errorSelectedService = true
          result = false
        }

        if (this.globalState.services[this.parentServiceId].has_service_items && !this.serviceItems) {
          this.errorServiceItems = true
          result = false
        }

        if (!this.packageType) {
          if (this.bookingType === 'normal') {
            if (this.$refs.cleaningDate.value === '') {
              this.errorBookingDateText = this.$i18n.t('message.booking.new_booking.date_is_required')
              this.errorBookingDate = true
              result = false
            }
            if (!this.selectedTime) {
              this.errorBookingTime = true
              result = false
            }
          }
        } else {
          switch (this.packageType.category) {
            case 'normal':
              if (this.multiDates === null || this.multiDates.length < this.packageType.num_per_package) {
                this.errorBookingDateText = this.$i18n.t('message.booking.new_booking.missing_dates_of_package')
                this.errorBookingDate = true
                result = false
              }
              if (!this.selectedTime) {
                this.errorBookingTime = true
                result = false
              }
              break
            case 'unlimited':
              if (this.multiDates === null || this.multiDates.length < this.packageType.min_qty) {
                this.errorBookingDateText = this.$i18n.t('message.booking.new_booking.missing_dates_of_package')
                this.errorBookingDate = true
                result = false
              }
              if (!this.selectedTime) {
                this.errorBookingTime = true
                result = false
              }
              break
          }
        }
        return result
      },
      goToCheckout () {
        if (this.formValidation()) {
          this.setPreBookingData()
          if (this.user == null || (this.user && Number(this.user.id) === 0)) {
            this.$parent.checkLogin()
          } else {
            if (!this.user.isPhoneVerified) {
              this.$parent.$parent.$parent.$refs.phoneVerificationModal.openModal()
            } else {
              // Go to checkout
              this.$store.commit('booking/SET_TMP_BOOKING_DATA', null)
              this.$store.commit('booking/SET_TMP_PRE_CHECKOUT_DATA', null)
              this.$router.push('/booking/start?step=2')
            }
          }
        }
      },
      calculateCost () {
        if (this.parentServiceId === 1) {
          const costPerHour = Number(this.globalState.provinceWages[this.selectedProvinceId].cost_per_hour)
          const workHour = Number(this.selectedWorkHour)
          let totalPrice = costPerHour * workHour
          const discount = provinceHelpers.getProvinceDiscount(this.globalState.provinceDiscounts, this.selectedProvinceId, this.selectedWorkHour)
          if (discount) {
            let discountCost = (totalPrice * discount) / 100
            discountCost = Math.round(discountCost * 100) / 100
            totalPrice = totalPrice - discountCost
          }
          this.subtotal = totalPrice

          // Check subscription selection
          if (this.subscriptionTypeId) {
            for (let key in this.globalState.subscriptionTypes) {
              const subscriptionType = this.globalState.subscriptionTypes[key]
              if (subscriptionType.id === this.subscriptionTypeId) {
                const numPerMonth = subscriptionType.num_per_month
                this.subtotal = this.subtotal * numPerMonth
                // Subscription discount
                const discountPercent = subscriptionType.discount
                let discountValue = (this.subtotal * discountPercent) / 100
                discountValue = Math.round(discountValue * 100) / 100
                this.subtotal = this.subtotal - discountValue
                break
              }
            }
          }

          // Check package type selection
          if (this.packageType) {
            switch (this.packageType.category) {
              case 'normal': {
                const numPerPackage = this.packageType.num_per_package
                this.subtotal = this.subtotal * numPerPackage
                // Package discount
                const discountPercent = this.packageType.discount
                let discountValue = (this.subtotal * discountPercent) / 100
                discountValue = Math.round(discountValue * 100) / 100
                this.subtotal = this.subtotal - discountValue
              }
                break
              case 'unlimited': {
                const numDates = (this.multiDates) ? this.multiDates.length : 0
                this.subtotal = this.subtotal * numDates
                const packageTypeDiscount = packageHelpers.getUnlimitedPackageDiscount(this.packageType, numDates)
                // Package discount
                if (packageTypeDiscount) {
                  const discountPercent = packageTypeDiscount.discount
                  let discountValue = (this.subtotal * discountPercent) / 100
                  discountValue = Math.round(discountValue * 100) / 100
                  this.subtotal = this.subtotal - discountValue
                }
              }
                break
              case 'flexible': {
                const numDates = this.packageTypeDiscount.booking_qty
                this.subtotal = this.subtotal * numDates
                // Package discount
                const discountPercent = this.packageTypeDiscount.discount
                let discountValue = (this.subtotal * discountPercent) / 100
                discountValue = Math.round(discountValue * 100) / 100
                this.subtotal = this.subtotal - discountValue
              }
            }
          }
        } else {
          if (!this.selectedServiceId) {
            this.subtotal = 0.0
          }
          if (this.childServices) {
            for (let key in this.childServices) {
              const service = this.childServices[key]
              if (service.id === this.selectedServiceId) {
                this.subtotal = service.cost
                break
              }
            }
          }
          if (this.serviceItems) {
            this.subtotal = serviceHelpers.getTotalPriceOfServiceItems(this.serviceItems)
          }
          // Check package type selection
          if (this.packageType) {
            switch (this.packageType.category) {
              case 'normal': {
                const numPerPackage = this.packageType.num_per_package
                this.subtotal = this.subtotal * numPerPackage
                // Package discount
                const discountPercent = this.packageType.discount
                let discountValue = (this.subtotal * discountPercent) / 100
                discountValue = Math.round(discountValue * 100) / 100
                this.subtotal = this.subtotal - discountValue
              }
                break
              case 'unlimited': {
                const numDates = (this.multiDates) ? this.multiDates.length : 0
                this.subtotal = this.subtotal * numDates
                const packageTypeDiscount = packageHelpers.getUnlimitedPackageDiscount(this.packageType, numDates)
                // Package discount
                if (packageTypeDiscount) {
                  const discountPercent = packageTypeDiscount.discount
                  let discountValue = (this.subtotal * discountPercent) / 100
                  discountValue = Math.round(discountValue * 100) / 100
                  this.subtotal = this.subtotal - discountValue
                }
              }
                break
              case 'flexible': {
                const numDates = this.packageTypeDiscount.booking_qty
                this.subtotal = this.subtotal * numDates
                // Package discount
                const discountPercent = this.packageTypeDiscount.discount
                let discountValue = (this.subtotal * discountPercent) / 100
                discountValue = Math.round(discountValue * 100) / 100
                this.subtotal = this.subtotal - discountValue
              }
            }
          }
        }
      },
      syncUserPlaceData () {
        if (this.selectedUserPlaceId) {
          this.selectedProvinceId = this.state.userPlaceCities[this.selectedUserPlaceId]
          this.selectedPlaceSize = this.state.userPlaceSizes[this.selectedUserPlaceId]
          this.selectedWorkHour = this.state.userPlaceWorkHours[this.selectedUserPlaceId]
          this.selectedProvinceId = (this.selectedProvinceId === 0) ? 1 : this.selectedProvinceId
        } else {
          this.selectedProvinceId = 1
          this.selectedPlaceSize = 1
          this.selectedWorkHour = '2.0'
        }
        this.resetServiceItems()
        this.calculateCost()
      },
      checkChangingCity (event) {
        // If change new city reset form values to default
        if (this.state.userPlaceCities && this.selectedUserPlaceId && Number(event.target.value) !== this.state.userPlaceCities[this.selectedUserPlaceId]) {
          // Reset form
          this.selectedUserPlaceId = null
          this.selectedPlaceSize = 1
          this.selectedWorkHour = '2.0'
        }
        this.selectedProvinceId = Number(event.target.value)
        this.resetServiceItems()
        this.calculateCost()
      },
      resetServiceItems () {
        // Reset service items
        this.errorServiceItems = false
        if (this.serviceItems && this.serviceItems.findIndex(item => item.province_id === Number(this.selectedProvinceId)) === -1) {
          this.serviceItems = null
        }
      },
      clearSelectedServiceItems () {
        this.serviceItems = null
        this.subtotal = 0.0
        this.$refs.serviceItemModal.clearData()
      },
      setWorkHour () {
        this.selectedWorkHour = this.globalState.placeSizeWorkHours[this.selectedPlaceSize]
        this.calculateCost()
      },
      syncServiceData () {
        if (this.parentServiceId === 1) {
          this.selectedServiceId = 1
        } else if (this.parentService.has_service_items) {
          this.selectedServiceId = this.parentService.id
        } else {
          switch (this.parentServiceId) {
            case 2:
              this.selectedServiceId = 4
              break
            case 7:
              this.selectedServiceId = 8
              break
          }
          this.updateServiceData()
        }
      },
      updateServiceData () {
        try {
          const serviceData = serviceHelpers.getServiceData(this.globalState.services, this.selectedServiceId)
          if (serviceData) {
            this.errorSelectedService = false
            this.errorSelectedServiceText = null
            this.selectedWorkHour = Number(serviceData.duration).toFixed(1)
          }
          this.calculateCost()
        } catch (e) {
          console.log('check updateServiceData error', e.message)
        }
      },
      fetchUserPlaces () {
        if (this.user) {
          const queryUserPlaceData = {
            user_id: this.user.id,
            province_id: 0
          }
          this.$store.dispatch('booking/LOAD_USER_PLACE_LIST', queryUserPlaceData)
        }
      },
      setAvailableTimes (nextAvailableTime) {
        this.availableTimes = []
        if (nextAvailableTime) {
          const arrTimes = this.globalState.arrTimes
          let startIndex = arrTimes.indexOf(nextAvailableTime)
          if (startIndex < 6) {
            startIndex = 6
          }
          for (let i = startIndex; i < arrTimes.length; i++) {
            this.availableTimes.push(arrTimes[i])
          }
          this.selectedTime = this.availableTimes[0]
        }
      },
      generateOptions () {
        const data = this.globalState.services
        for (let key in data) {
          const service = data[key]
          if (service.parent_id === this.parentServiceId && service.status === 1 && service.is_hidden === 0) {
            this.childServices.push(service) // for displaying service price
            const option = {text: service.duration, value: service.id}
            this.thaiMassageOptions.push(option)
          }
        }
      },
      generateChildServices () {
        if (this.parentServiceId > 1 && this.globalState.services[this.parentServiceId].child_services_text) {
          // this.selectedServiceId = (this.parentServiceId === 2) ? 4 : 8
          this.selectedServiceId = null
          if (this.parentServiceId === 7) {
            this.selectedServiceId = 8
          }
          this.childServices = {}
          const datas = this.globalState.services
          // let i = 0
          for (let key in datas) {
            const service = datas[key]
            if (service.parent_id === this.parentServiceId) {
              const id = service.id
              // Bathroom cleaning child services based on province
              if (service.province_id === 0 || Number(this.selectedProvinceId) === service.province_id) {
                this.childServices[id] = {
                  id: service.id,
                  parent_id: service.parent_id,
                  name_th: service.name_th,
                  name_en: service.name_en,
                  duration: service.duration,
                  cost: service.cost
                }
              }
            }
          }
        }
      },
      checkAvailableService () {
        const submitData = {
          'parent_service_id': this.parentServiceId,
          'selected_date': moment(this.calendarData.date, 'DD/MM/YYYY').format('YYYY-MM-DD')
        }
        this.$store.dispatch('booking/CHECK_AVAILABLE_SERVICE', submitData)
      },
      checkSubscriptionType () {
        if (this.$route.query.subscriptionTypeId) {
          this.subscriptionTypeId = Number(this.$route.query.subscriptionTypeId)
        }
      },
      selectPackageType (selectedCategory) {
        if (this.multiDates) {
          this.multiDates = null
        }
        // Clear selected service id if not cleaning service
        if (this.parentServiceId !== 1) {
          this.selectedServiceId = null
        }
        this.packageType = null
        if (this.globalState.packageTypes) {
          for (const packageType of this.globalState.packageTypes) {
            if (packageType.category === selectedCategory) {
              this.packageType = packageType
              if (selectedCategory === 'flexible') {
                this.packageTypeDiscount = packageType.package_type_discounts[0]
                this.calculateCost()
              }
              break
            }
          }
        }
      },
      setServiceItems (serviceItems) {
        if (serviceItems) {
          this.serviceItems = []
        }
        this.serviceItems = serviceItems
        this.calculateCost()
        this.errorServiceItems = false
      }
    },
    async mounted () {
      // Assign parent service id
      if (this.$route.query.sid) {
        this.parentServiceId = parseInt(this.$route.query.sid)
      } else {
        this.parentServiceId = 1
      }
      // Load global data to config disable same day booking
      this.calendarData.sameDayBookingConfig = serviceHelpers.formatSameDayData(this.globalState.configData.same_day_booking)
      // this.parentServiceId = 1
      // Check service
      if (this.parentServiceId) {
        this.parentService = this.globalState.services[this.parentServiceId]
        this.generateChildServices()
        if (this.parentServiceId === 7) {
          this.generateOptions()
        }
      }
      this.calendarData.serviceId = this.parentServiceId
      this.calendarData.provinceId = this.selectedProvinceId
      this.checkSubscriptionType()
      this.syncServiceData()
      this.setFormData()
      this.fetchUserPlaces()
      this.$store.commit('booking/SET_BOOKING_CURRENT_STEP', 1)
      // Set available times
      this.availableTimes = this.globalState.arrTimes
      this.checkBookingDate()
      if (this.parentServiceId === 7) {
        this.checkAvailableService()
      }
      if (this.$route.query.subscriptionTypeId) {
        this.openSubscriptionDetailModal()
      }
      // Save user event log
      if (!this.$route.query.step || (this.$route.query.step && Number(this.$route.query.step) !== 2)) {
        userEventLogHelpers.logEvent('begin_booking', {
          service_id: this.parentServiceId
        })
      }
    }
  }
</script>

<style scoped>
  .badge-light {
    background-color: #E0E0E0;
  }

  .input-text-icon {
    float: right;
    margin-right: 1rem;
    margin-top: -2.15rem;
    position: relative;
    font-size: 120%;
    z-index: 2;
    color: #9E9E9E;
  }
</style>



// WEBPACK FOOTER //
// src/components/booking/newSteps/Booking.vue